var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlignmentLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 24,
    viewBox: "0 0 40 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4576_70647)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.3951 0H3.60494C1.61399 0 0 2.10751 0 4.70726V19.2927C0 21.8925 1.61399 24 3.60494 24H36.3951C38.386 24 40 21.8925 40 19.2927V4.70726C40 2.10751 38.386 0 36.3951 0Z",
    fill: "#265183"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7616 3.68359H6.23887C4.62969 3.68359 3.3252 5.38698 3.3252 7.48821V16.5074C3.3252 18.6086 4.62969 20.312 6.23887 20.312H33.7616C35.3707 20.312 36.6752 18.6086 36.6752 16.5074V7.48821C36.6752 5.38698 35.3707 3.68359 33.7616 3.68359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6563 5.76172H9.1933C6.83587 5.76172 4.9248 7.46511 4.9248 9.56634V14.4357C4.9248 16.5369 6.83587 18.2403 9.1933 18.2403H14.6563C17.0137 18.2403 18.9248 16.5369 18.9248 14.4357V9.56634C18.9248 7.46511 17.0137 5.76172 14.6563 5.76172Z",
    fill: "#265183"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4576_70647"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignmentLeft);
export default __webpack_public_path__ + "static/media/alignment-left.cc7aad6fd325c4c482d6dd17d0e6e8a7.svg";
export { ForwardRef as ReactComponent };